var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheckWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2999 21.6001H5.49984C4.17436 21.6001 3.09984 20.5256 3.09985 19.2001L3.09995 4.80013C3.09995 3.47466 4.17447 2.40015 5.49995 2.40015H16.3002C17.6257 2.40015 18.7002 3.47466 18.7002 4.80015V11.4001M13.9002 18.2001L16.1002 20.4001L20.9002 15.6M7.30023 7.20015H14.5002M7.30023 10.8001H14.5002M7.30023 14.4001H10.9002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheckWidth2);
export default __webpack_public_path__ + "static/media/file-check-width-2.b3108eb4e807c28480898a11a68f2773.svg";
export { ForwardRef as ReactComponent };